const appointmentTrigger = document.getElementById('book-appointment-trigger');

if(appointmentTrigger) {

  // Ref: https://developers.acuityscheduling.com/docs/embedding

  const appointmentOverlay = document.getElementById('book-appointment-overlay');
  let productTitle = encodeURIComponent(appointmentOverlay.getAttribute('data-product-title'));
  let productHandle = appointmentOverlay.getAttribute('data-product-handle');
  let productLink = `${window.location.origin}/products/${productHandle}`;
  let acuityAppointmentsParams = '&appointmentType[]=57583349&appointmentType[]=57632489'; // Specific Piece appointments (in-store and virtual)
  let acuityDynamicDataParams = `&field:14420160=${productTitle}&field:14420323=${productLink}`; // Product title and product URL
  let acuityScheduleLink = `https://app.acuityscheduling.com/schedule.php?owner=22478978${acuityAppointmentsParams}${acuityDynamicDataParams}`;
  let acuityIframe = `<iframe src="${acuityScheduleLink}" title="Schedule Appointment" frameBorder="0"></iframe>`;
  let acuityLoaded = false;

  appointmentTrigger.addEventListener('click', e => {
    // Prevent link opening, load Acuity embed in modal instead
    e.preventDefault();
    appointmentOverlay.classList.add('active');
    handleFixedElements('hide');
    if(acuityLoaded == false) {
      appointmentOverlay.querySelector('.modal-main .acuity-embed').innerHTML = acuityIframe;
      // script src="https://embed.acuityscheduling.com/js/embed.js"
      // Script not needed, iframe loads and functions as expected
      acuityLoaded = true;
    }
    // Track clicks in GA
    if(window.gtag) {
      let appointmentCtaClickObj = {'product_title': appointmentOverlay.getAttribute('data-product-title')};
      gtag('event', 'product_book_appointment_cta_click', appointmentCtaClickObj);
    }
  });

} // if(appointmentTrigger)